import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const primaryBlueColaColor = '#0095EB';
const brandBeaverColor = '#A18E72';
const whiteColor = '#FFFFFF';

const grey500Color = '#979797';
const grey300Color = '#BFBFBF';

const viseudesusLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#E53935',
    info: '#2196F3',
    primary: primaryBlueColaColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB8C00',
    background: whiteColor,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: brandBeaverColor,
    systemToolbar: brandBeaverColor,
    navigationDrawer: brandBeaverColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': '#4A4A4A',
    'on-systemToolbar': whiteColor,
  },
};

export const viseudesusTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: viseudesusLightTheme,
  },
};
